<template>
  <div :class="css">
    <input type="checkbox"
           :id="id"
           @input="$emit('input', !model)"
           :required="{required: required}"
           v-model="model">
    <label :for="id" style="margin-left: 7px;">
      {{ label }}
    </label>
  </div>
</template>

<script>
  export default {
    props: {
      required: {
        required: true,
        type: Boolean,
        default: false
      },
      id: {
        required: true,
        type: String
      },
      label: {
        required: true,
        type: String
      }
    },
    data() {
      return {
        model: null
      }
    },
    computed: {
      css() {
        return {
          'form-group': true,
          'checkbox': true,
          'required': this.required
        }
      }
    }
  }
</script>